import ColorByStatus from './ColorByStatus'

function GridCBUStatus({ able, validated }) {
  const error = !validated || !able
  let IdentityStatus = ''
  if (validated) {
    IdentityStatus = 'Identidad Validada'
  } else if (!able) {
    IdentityStatus = 'Deshabilitado'
  } else {
    IdentityStatus = 'Identidad Pendiente'
  }

  return <ColorByStatus error={error} message={IdentityStatus} />
}

export default GridCBUStatus
